<template>
    <div class="rows">
        <div style="margin-bottom: 10px;">
            <table class="table-border-none">
                <tr>
                    <td style="padding-left: 0;">Název:</td>
                    <td><input v-model="item.nazev" style="width: 400px;" /><span class="required">*</span></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Typ DOSS:</td>
                    <td>
                        <select v-model="item.idTyp" style="width: 400px;">
                            <option :value="-1">&lt; vyberte typ DOSS &gt;</option>
                            <option v-for="(typ, i) in sortedTypDOSS" :key="i" :value="typ.id">{{ typ.nazev }}</option>
                        </select>
                        <span class="required">*</span>
                    </td>
                </tr>
            </table>
        </div>
        <div class="cols" style="gap: 10px;">
            <button @click="saveItem">Uložit</button>
            <button @click="close">Zavřít</button>
            <button v-if="itemId !== -1" @click="deleteItem">Smazat</button>
        </div>
    </div>
</template>

<script>
    import api from '@/api/api.js'
    import _ from 'lodash'

    export default {
        name: 'EditDOSS',
        props: ['itemId'],
        data() {
            return {
                item: {
                    'id': -1,
                    'idTyp': -1,
                    'nazev': '',
                    'typDOSS': ''
                },
                typDOSS: []
            }
        },
        computed: {
            sortedTypDOSS() {
                return _.orderBy(this.typDOSS, 'kategorie')
            }
        },
        methods: {
            load() {
                this.$progress.start()
                api.getTypDOSS()
                .then(response => {
                    this.$progress.finish()
                    this.typDOSS = response.data
                })
                .catch(error => { 
                    this.$progress.finish()
                    console.log('Error: ', error)
                })

                if (this.itemId === -1) {
                    this.item = {
                        'id': -1,
                        'idTyp': -1,
                        'nazev': '',
                        'typDOSS': ''
                    }
                }
                else {
                    this.$progress.start()
                    api.getDOSSById(this.itemId)
                    .then(response => {
                        this.$progress.finish()
                        this.item = response.data
                    })
                    .catch(error => { 
                        this.$progress.finish()
                        console.log('Error: ', error)
                    })
                }
            },
            close() {
                this.$emit('close')
            },
            saveItem() {
                if (confirm('Uložit záznam?')) {
                    if (this.item.nazev.length === 0 || this.item.idTyp === -1) {
                        alert('Záznam nebude uložen. Povinná pole jsou: Název, Typ DOSS')
                        return
                    }
                    else {
                        if (this.item.id === -1) {
                            this.$progress.start()
                            api.postDOSS(this.item)
                            .then(() => {
                                this.$progress.finish()
                                this.$emit('updateTable')
                                this.$emit('close')
                            })
                            .catch(error => { 
                                this.$progress.finish()
                                console.log('Error: ', error)
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                            })
                        }
                        else {
                            this.$progress.start()
                            api.putDOSS(this.item.id, this.item)
                            .then(() => {
                                this.$progress.finish()
                                this.$emit('updateTable')
                            })
                            .catch(error => { 
                                this.$progress.finish()
                                console.log('Error: ', error)
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                            })
                        }
                    }
                }
            },
            deleteItem() {
                if (confirm('VAROVÁNÍ! Tuto akci nelze vzít zpátky. Opravdu chcete smazat tento záznam?')) {
                    this.$progress.start()
                    api.deleteDOSS(this.item.id)
                    .then(() => {
                        this.$progress.finish()
                        this.$emit('updateTable')
                        this.$emit('close')
                    })
                    .catch(error => { 
                        this.$progress.finish()
                        console.log('Error: ', error)
                        alert('Nastala chyba při mazání. Záznam nebyl smazán.')
                    })
                }
            }
        },
        created() {
            this.load()
        },
        beforeUpdate() {
            if (this.itemId !== this.item.id) {
                this.load()
            }
        }
    }
</script>